import React from "react";

const projects = [
  {
    title: "Justlogistics",
    description:
      "Plataforma web para optimizar la gestión logística de empresas de transporte y distribución, con seguimiento en tiempo real, inventarios y analítica.",
    image: "https://i.postimg.cc/DzY0SyTZ/Captura-de-pantalla-2026-01-15-092737.png",
    link: "https://justlogistics.com.co/",
  },
  {
    title: "Club de Baloncesto Cúcuta Norte",
    description:
      "Página oficial del club deportivo con noticias, galería, información institucional y sistema de contacto para inscripciones.",
    image: "https://i.postimg.cc/sgnngy3J/clubdepo.png",
    link: "https://clubdebaloncestocucutanortedesantander.com/",
  },
  {
    title: "El Caminante",
    description:
      "Plataforma de ventas online orientada a comercio minorista con diseño responsive y experiencia de compra simplificada.",
    image: "https://i.postimg.cc/bdX2sY1H/Captura-de-pantalla-2026-01-15-093740.png",
    link: "https://690403167154a17d071538d1--euphonious-stardust-6b80fe.netlify.app/",
  },
  {
    title: "Central Mayorista Digital",
    description:
      "Solución digital para conectar comerciantes y clientes, optimizando la cadena de suministro y procesos de compra.",
    image: "https://i.postimg.cc/mrGv7BvT/centralmayy.png",
    link: "https://centralmayoristadigital.web.app/",
  },
  {
    title: "Mar&Mar Beauty",
    description:
      "Plataforma de comercio electrónico desarrollada con Angular y Firebase para gestión de productos y ventas online.",
    image: "https://i.postimg.cc/4dN0Ss7y/Captura-de-pantalla-2026-01-15-094551.png",
    link: "https://marymarbeauty-7f19d.web.app/",
  },
  {
    title: "YEDA",
    description:
      "Startup orientada a la gestión de contactos y procesos internos, desarrollada con Angular y Firebase.",
    image: "https://i.postimg.cc/rpb4v9z7/Captura-de-pantalla-2026-01-15-093935.png",
    link: "https://yeda-fcaf0.web.app/",
  },
];

const Projects = () => {
  return (
    <section
      id="projects"
      aria-label="Proyectos"
      className="relative py-20"
    >
      {/* Fondo sutil para continuidad visual */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#f6f7f4] via-white to-[#eef2ee]" />

      <div className="relative max-w-6xl mx-auto px-4">
        {/* Título */}
        <div className="mb-10">
          <h2 className="font-poppins text-3xl font-semibold tracking-tight text-slate-900">
            Proyectos Destacados
          </h2>
          <p className="mt-3 max-w-2xl text-slate-600">
            Una selección de proyectos donde he trabajado en diseño, desarrollo
            frontend y soluciones escalables enfocadas en experiencia de usuario.
          </p>
        </div>

        {/* Grid */}
        <div className="grid gap-6 sm:grid-cols-2">
          {projects.map((project, index) => (
            <a
              key={index}
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-2xl border border-[#3f5232]/15 bg-white/70 backdrop-blur shadow-sm
                         transition hover:-translate-y-1 hover:shadow-md"
            >
              {/* Imagen */}
              <div className="relative overflow-hidden rounded-t-2xl">
                <img
                  src={project.image}
                  alt={project.title}
                  className="h-52 w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent opacity-0 group-hover:opacity-100 transition" />
              </div>

              {/* Contenido */}
              <div className="p-5">
                <h4 className="text-lg font-semibold text-slate-900 group-hover:text-[#3f5232] transition">
                  {project.title}
                </h4>

                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  {project.description}
                </p>

                <div className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#3f5232]">
                  Ver proyecto
                  <span className="transition group-hover:translate-x-1">→</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
